export default __webpack_public_path__ + "static/media/image01.bc9567d5.jpg";